<template>
    <div class="container shadow-lg">
      <div hidden class="row pt-2 text-start mt-1 pb-1" style="background:CornflowerBlue">
          <div class="col-6">
              <h5>
                  <span class="badge rounded-pill text-dark p-2 px-3" style="background:white">
                  <b>ข้อมูลคลินิก</b>
                  </span>
              </h5>
          </div>
          <div class="col-6">
              <!-- <button type="button" class="btn btn-primary btn-sm pt-2 float-sm-end " data-bs-toggle="modal" data-bs-target="#exampleModal" @click="saveData()" style="width:100px;">บันทึกข้อมูล</button> -->
          </div>
      </div>
      <div class="row ">
        <div class="col-sm px-3 pt-1 pb-3" style="background-color:Gainsboro">
            <form id="fmCorp" @submit.prevent="" >
                <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                <div class="row mb-2 p-2" style="background:Wheat">
                    <div class="col-6 text-start">
                        <div class="input-group input-group-sm">
                            <span class="input-group-text" style="width:110px;">MEMBER *</span>
                            <input ref="menbername" type="text" readonly class="form-control form-control-sm" name="menbername" v-model="curRecord.MemberName">
                            <button class="btn btn-outline-primary ms-2">เปลี่ยนรหัสผ่าน..</button>
                        </div>
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col-6 text-start">
                        <div class="input-group input-group-sm">
                          <span class="input-group-text" style="width:110px;">รหัสคลิกนิก*</span>
                          <input ref="corpcode" type="text" class="form-control form-control-sm" name="CorpCode"  v-model="curRecord.CorpCode">
                        </div>
                    </div>
                </div>
                <div class="row">
                  <!-- LEFT : ชื่อ ที่อยู่คลินิก ใช้ในระบบ -->
                  <div class="col-sm-6">
                    <h6 class="text-white bg-secondary py-1 mt-2">ชื่อที่อยู่คลินิก</h6>
                    <div class="row mb-1">
                        <div class="col-12 text-start">
                            <div class="input-group input-group-sm">
                              <span class="input-group-text" style="width:180px;">ชื่อคลินิก* (Th)</span>
                              <input ref="corpname" type="text" class="form-control form-control-sm" name="CorpName" v-model="curRecord.CorpName">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-12 text-start">
                            <div class="input-group input-group-sm">
                              <span class="input-group-text" style="width:180px;">ชื่อคลินิก* (En)</span>
                              <input ref="corpname2" type="text" class="form-control form-control-sm" name="CorpName2" v-model="curRecord.CorpName2">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-12 text-start">
                            <div class="input-group input-group-sm">
                              <span class="input-group-text" style="width:180px;">เลขประจำตัวผู้เสียภาษี</span>
                              <input type="text" class="form-control form-control-sm" name="TaxID" v-model="curRecord.TaxID">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1 text-start">
                        <div class="col">
                            <label for="addr1" class="mr-sm-2">ที่อยู่:</label>
                            <input type="text" class="form-control mb-1" id="addr1" placeholder="ที่อยู่" name="Addr1" autocomplete="off" v-model="curRecord.Addr1">
                            <input type="text" class="form-control" id="addr2" placeholder="ที่อยู่ (เพิ่มเติม)" name="Addr2" autocomplete="off" v-model="curRecord.Addr2">
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-6">
                            <input type="text" class="form-control" id="tambol" placeholder="ตำบล" name="Tambol" autocomplete="off" v-model="curRecord.Tambol">
                        </div>
                        <div class="col-6">
                            <input type="text" class="form-control" id="amphor"  placeholder="อำเภอ" name="Amphor" autocomplete="off" v-model="curRecord.Amphor">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <input type="text" class="form-control" id="province"  placeholder="จังหวัด" name="Province" autocomplete="off" v-model="curRecord.Province">
                        </div>
                        <div class="col-6">
                            <input type="text" class="form-control" id="postcode"  placeholder="รหัสไปรษณีย์" name="Zipcode" autocomplete="off" v-model="curRecord.Zipcode">
                        </div>
                    </div>
                    <div class="row mb-1 text-start">
                        <label for="tel1" class="mr-sm-2">Phone :</label>
                        <div class="col-6">
                            <input type="text" class="form-control" id="phone1" placeholder="Phone no.1" name="Tel1" v-model="curRecord.Tel1">
                        </div>
                        <div class="col-6">
                            <input type="text" class="form-control" id="phone2"  placeholder="Phone no.2" name="Tel2" v-model="curRecord.Tel2">
                        </div>
                    </div>
                    <div class="row  text-start">
                        <label for="Email1" class="mr-sm-2">Email:</label>
                        <div class="col-6">
                            <input type="text" class="form-control" id="email1" placeholder="Enter email#1" name="Email1" v-model="curRecord.Email1">
                        </div>
                        <div class="col-6">
                            <input type="text" class="form-control mb-1" id="email2" placeholder="Enter email#2" name="Email2" v-model="curRecord.Email2">
                        </div>
                    </div>
                    <div class="row  text-start">
                        <label for="Fax" class="mr-sm-2">Fax :</label>
                        <div class="col-6">
                            <input type="text" class="form-control" id="fax" placeholder="Enter fax" name="Fax" v-model="curRecord.Fax">
                        </div>
                        <div class="col-6">
                        </div>
                    </div>
                  </div>
                  <!-- RIGHT : ชื่อ ที่อยู่บริษัท สำหรับออกใบแจ้งหนี้ -->
                  <div class="col-sm-6 text-danger">
                    <h6 class="text-dark bg-warning py-1 mt-2">ชื่อที่อยู่คลินิกสำหรับใบเสร็จ/ใบแจ้งหนี้</h6>
                    <div class="row mb-1">
                        <div class="col-12 text-start">
                            <div class="input-group input-group-sm">
                              <span class="input-group-text" style="width:180px;">ชื่อบริษัท * (Th)</span>
                              <input ref="corpname" type="text" class="form-control form-control-sm" name="InvcCorpName" v-model="curRecord.InvcCorpName">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-12 text-start">
                            <div class="input-group input-group-sm">
                              <span class="input-group-text" style="width:180px;">ชื่อบริษัท * (En)</span>
                              <input ref="corpname2" type="text" class="form-control form-control-sm" name="InvcCorpName2" v-model="curRecord.InvcCorpName2">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-12 text-start">
                            <div class="input-group input-group-sm">
                              <span class="input-group-text" style="width:180px;">เลขประจำตัวผู้เสียภาษี</span>
                              <input type="text" class="form-control form-control-sm" name="InvcTaxID" v-model="curRecord.InvcTaxID">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1 text-start">
                        <div class="col">
                            <label for="addr1" class="mr-sm-2">ที่อยู่:</label>
                            <input type="text" class="form-control mb-1" id="addr1" placeholder="ที่อยู่" name="InvcAddr1" autocomplete="off" v-model="curRecord.InvcAddr1">
                            <input type="text" class="form-control" id="addr2" placeholder="ที่อยู่ (เพิ่มเติม)" name="InvcAddr2" autocomplete="off" v-model="curRecord.InvcAddr2">
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-6">
                            <input type="text" class="form-control" id="tambol" placeholder="ตำบล" name="InvcTambol" autocomplete="off" v-model="curRecord.InvcTambol">
                        </div>
                        <div class="col-6">
                            <input type="text" class="form-control" id="amphor"  placeholder="อำเภอ" name="InvcAmphor" autocomplete="off" v-model="curRecord.InvcAmphor">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <input type="text" class="form-control" id="province"  placeholder="จังหวัด" name="InvcProvince" autocomplete="off" v-model="curRecord.InvcProvince">
                        </div>
                        <div class="col-6">
                            <input type="text" class="form-control" id="postcode"  placeholder="รหัสไปรษณีย์" name="InvcZipcode" autocomplete="off" v-model="curRecord.InvcZipcode">
                        </div>
                    </div>
                    <div class="row mb-1 text-start">
                        <label for="tel1" class="mr-sm-2">Phone :</label>
                        <div class="col-6">
                            <input type="text" class="form-control" id="phone1" placeholder="Phone no.1" name="InvcTel1" v-model="curRecord.InvcTel1">
                        </div>
                        <div class="col-6">
                            <input type="text" class="form-control" id="phone2"  placeholder="Phone no.2" name="InvcTel2" v-model="curRecord.InvcTel2">
                        </div>
                    </div>
                    <div class="row  text-start">
                        <label for="Email1" class="mr-sm-2">Email:</label>
                        <div class="col-6">
                            <input type="text" class="form-control" id="email1" placeholder="Enter email#1" name="InvcEmail1" v-model="curRecord.InvcEmail1">
                        </div>
                        <div class="col-6">
                            <input type="text" class="form-control mb-1" id="email2" placeholder="Enter email#2" name="InvcEmail2" v-model="curRecord.InvcEmail2">
                        </div>
                    </div>
                    <div class="row  text-start">
                        <label for="Fax" class="mr-sm-2">Fax :</label>
                        <div class="col-6">
                            <input type="text" class="form-control" id="fax" placeholder="Enter fax" name="InvcFax" v-model="curRecord.InvcFax">
                        </div>
                        <div class="col-6">
                        </div>
                    </div>
                  </div>
                </div>
            </form>
        </div>
      </div>
      <div class="row py-2 bg-light">
        <div class="col">
          <button type="button" class="btn btn-primary btn-sm pt-2" @click="saveData()" style="width:100px;">บันทึกข้อมูล</button>
        </div>
      </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'ClinicReq',
  components: {

  },
  data () {
    return {
      curRecord: {
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      MyApiClient.get('getdata/corpInfo_where_id.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.curRecord.MemberName = resp.data.MemberName
          this.curRecord.TaxID = resp.data.TaxID
          this.curRecord.CorpCode = resp.data.CorpCode
          this.curRecord.CorpName = resp.data.CorpName
          this.curRecord.CorpName2 = resp.data.CorpName2
          this.curRecord.Addr1 = resp.data.Addr1
          this.curRecord.Addr2 = resp.data.Addr2
          this.curRecord.Tambol = resp.data.Tambol
          this.curRecord.Amphor = resp.data.Amphor
          this.curRecord.Province = resp.data.Province
          this.curRecord.Zipcode = resp.data.Zipcode
          this.curRecord.Tel1 = resp.data.Tel1
          this.curRecord.Tel2 = resp.data.Tel2
          this.curRecord.Fax = resp.data.Fax
          this.curRecord.Email1 = resp.data.Email1
          this.curRecord.Email2 = resp.data.Email2

          this.curRecord.InvcTaxID = resp.data.InvcTaxID
          this.curRecord.InvcCorpName = resp.data.InvcCorpName
          this.curRecord.InvcCorpName2 = resp.data.InvcCorpName2
          this.curRecord.InvcAddr1 = resp.data.InvcAddr1
          this.curRecord.InvcAddr2 = resp.data.InvcAddr2
          this.curRecord.InvcTambol = resp.data.InvcTambol
          this.curRecord.InvcAmphor = resp.data.InvcAmphor
          this.curRecord.InvcProvince = resp.data.InvcProvince
          this.curRecord.InvcZipcode = resp.data.InvcZipcode
          this.curRecord.InvcTel1 = resp.data.InvcTel1
          this.curRecord.InvcTel2 = resp.data.InvcTel2
          this.curRecord.InvcFax = resp.data.InvcFax
          this.curRecord.InvcEmail1 = resp.data.InvcEmail1
          this.curRecord.InvcEmail2 = resp.data.InvcEmail2

          // console.log(this.curRecord)
          // console.log(resp.data)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    saveData () {
      var self = this
      // แปลงข้อมูลจากฟอร์ม
      var x = $('#fmCorp').serializeArray()
      var formData = {}
      $.each(x, function (i, field) {
        $.extend(formData, { [field.name]: field.value })
      })
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/update_corpinfo.php',
        data: { request: JSON.stringify(formData) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            // Refresh >> this component only
            // this.$refs.getData()
            self.getData()
            // location.reload()
            // this.$router.push('MClinics')
          })
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    }
  }
}
</script>
<style>

</style>
